/**
 * Wrapper around floating panel
 * Handles visibilty state
 */
import { useDispatch, useSelector } from 'react-redux';
import { actionClearTransactionStatuses } from '../../actions/transactions';
import FloatingStatusBar from '../../molecules/FloatingStatusBar';
import { IStore } from '../../reducers';

/**
 * Shows floating transactions status bar
 * Takes data from redux and just renders state
 * @param props
 * @returns
 */
const TransactionsStatus = () => {
  const dispatch = useDispatch();

  const transactions = useSelector((store: IStore) => store.transactions);

  const onClose = () => {
    dispatch(actionClearTransactionStatuses());
  };

  if (transactions.length > 0) {
    return <FloatingStatusBar transactions={transactions} onClose={onClose} />;
  }
  return null;
};

export default TransactionsStatus;
